// extracted by mini-css-extract-plugin
export default {"overlay":"modal-overlay_overlay__7gou6"};